import { useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { usePostsLayoutState } from './usePostsLayoutState';
import { resolvePostModalHashForPreference } from '../utils/postModalDeepLinkHash';

export function usePostModalDeepLinkSync() {
  const location = useLocation();
  const navigate = useNavigate();
  const isNewPostExperienceActive = usePostsLayoutState(
    (state) => state.isNewPostExperienceActive,
  );

  useLayoutEffect(() => {
    const normalizedHash = resolvePostModalHashForPreference(
      location.hash,
      isNewPostExperienceActive,
    );

    if (normalizedHash) {
      navigate(
        { hash: normalizedHash, search: location.search },
        { replace: true, state: location.state },
      );
    }
    // Runs once on mount only: all layout effects (this one) are guaranteed
    // by React to finish - including the synchronous re-render triggered by
    // navigate() above - before any passive effect runs, so ModalRouter's
    // own hash-driven effect never observes the stale, unnormalized hash
    // and the wrong post modal never mounts, even for a single frame.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
